import React from 'react'
import PlayTime from 'components/ui/play-time'
import styles from './index.module.css'

type Props = {
  progress: number
  duration: number
}

const ScrollableWaveformProgress = ({
  progress,
  duration,
}: Props): React.ReactElement<'div'> => {
  return (
    <div className={styles.scrollableWaveformProgress}>
      <div className={styles.scrollableWaveformProgressProgress}>
        <PlayTime time={progress} />
      </div>
      <div className={styles.scrollableWaveformProgressSplitter} />
      <div className={styles.scrollableWaveformProgressDuration}>
        <PlayTime time={duration} />
      </div>
    </div>
  )
}

export default ScrollableWaveformProgress
